import { useGeocodeLookupApiV1GeocodeGet } from '#/shared/api/generated/shipment/theCargoShipment'
import type { GeoCodeResponse } from '#/shared/api/generated/shipment/models'

export interface GeocodedPoint {
  lat: number
  lng: number
}

export interface UseRouteGeocodeResult {
  origin: GeocodedPoint | undefined
  destination: GeocodedPoint | undefined
  isLoading: boolean
  isError: boolean
}

interface EndpointState {
  point: GeocodedPoint | undefined
  isLoading: boolean
  isFailed: boolean
}

function toPoint(data: GeoCodeResponse | undefined): GeocodedPoint | undefined {
  if (!data) return undefined
  if (data.latitude == null || data.longitude == null) return undefined
  return { lat: data.latitude, lng: data.longitude }
}

function useGeocodedEndpoint(
  address: string | undefined,
  enabled: boolean,
): EndpointState {
  const active = enabled && Boolean(address)
  const query = useGeocodeLookupApiV1GeocodeGet(
    { q: address ?? '' },
    { query: { enabled: active } },
  )
  const point = toPoint(query.data?.data[0])
  return {
    point,
    isLoading: active && !query.isFetched,
    isFailed:
      active && query.isFetched && (query.isError || point === undefined),
  }
}

export function useRouteGeocode(
  originAddress: string | undefined,
  destinationAddress: string | undefined,
  enabled: boolean,
): UseRouteGeocodeResult {
  const origin = useGeocodedEndpoint(originAddress, enabled)
  const destination = useGeocodedEndpoint(destinationAddress, enabled)
  return {
    origin: origin.point,
    destination: destination.point,
    isLoading: origin.isLoading || destination.isLoading,
    isError: origin.isFailed || destination.isFailed,
  }
}
